import React from 'react'
import Flex from 'typescript-styled-flex'
import { connect } from 'react-redux'
import { is } from '../../../components/MediaQuery'
import { getSelectedLanguage } from '../../../reducers/userAccount/selectors/userLanguage'
import mapCodeToDownloadBadge from '../../../i18n/mappers/mapCodeToDownloadBadge'
import Label from './Label'
import Label2 from './Label2'

function SliderItem({
  lang,
  header,
  image,
  label,
  footer,
  downloadButtons = false,
  maxWidth = '100%',
}) {
  const isDesktop = is.desktop()

  function redirect(type: 'android' | 'ios') {
    const android =
      'https://play.google.com/store/apps/details?id=com.rst.bedbooking'
    const ios = 'https://itunes.apple.com/US/app/id826280602?mt=8'

    return function() {
      window.open(type === 'android' ? android : ios, '_blank')
    }
  }

  return (
    <Flex full={true} column={true}>
      <Label style={isDesktop ? { marginTop: '0' } : {}}>{header}</Label>
      <div
        style={{
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <img style={{ height: 'auto', width: maxWidth }} src={image} alt={''} />
      </div>
      <Label2>{label}</Label2>
      {downloadButtons && (
        <Flex justifyCenter={true} alignCenter={true}>
          <img
            onClick={redirect('android')}
            style={{
              cursor: 'pointer',
              height: '58px',
              minHeight: '40px',
              minWidth: '135px',
              width: '143px',
            }}
            alt={''}
            src={mapCodeToDownloadBadge('android', lang)}
          />
          <img
            onClick={redirect('ios')}
            style={{
              cursor: 'pointer',
              height: '40px',
              minHeight: '40px',
              minWidth: '135px',
              width: '135px',
            }}
            src={mapCodeToDownloadBadge('ios', lang)}
            alt={''}
          />
        </Flex>
      )}
      <Label style={{ marginTop: downloadButtons ? '7px' : '30px' }}>
        {footer}
      </Label>
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  lang: getSelectedLanguage(state),
})

export default connect(mapStateToProps)(SliderItem)
